require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/registrer/RegistredModule.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/registrer/RegistredModule.legacy.js
// module id = 720
// module chunks = 31